import { supabase } from '../lib/supabase';

export const emailService = {
  /**
   * Send welcome email to new subscriber
   * @param {string} email - Subscriber email address
   * @param {string|null} firstName - Subscriber first name (optional)
   * @returns {Promise<{success: boolean, message: string, error?: string}>}
   */
  async sendWelcomeEmail(email, firstName = null) {
    try {
      // Call the Supabase Edge Function with timeout
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller?.abort(), 10000); // 10 second timeout

      const { data, error } = await supabase?.functions?.invoke(
        'send-welcome-email',
        {
          body: {
            email: email?.toLowerCase()?.trim(),
            firstName: firstName?.trim() || null
          },
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      clearTimeout(timeoutId);

      if (error) {
        console.error('Edge function error:', error);
        // Don't throw - return failure status instead
        return {
          success: false,
          message: 'Failed to send welcome email',error: error?.message || 'Edge Function returned an error'
        };
      }

      // Check if response indicates success
      if (data?.success === false || data?.error) {
        console.error('Email sending failed:', data?.error);
        return {
          success: false,
          message: 'Failed to send welcome email',
          error: data?.error || 'Unknown error from email service'
        };
      }

      return {
        success: true,
        message: 'Welcome email sent successfully',
        data
      };
    } catch (error) {
      console.error('Email service error:', error);
      // Return failure status instead of throwing
      return {
        success: false,
        message: 'Failed to send welcome email',
        error: error?.message || 'Network error or timeout'
      };
    }
  }
};